module.exports = __webpack_public_path__ + "static/media/Orientamento 3.bf9d2ad7.png";